import { Injectable } from '@angular/core';
import { CommonComponentStore } from './../../shared/component-store/common-component-store';
import { IPod } from 'src/app/shared/models/item.models';
import { PodService } from './pods.service';
import { ItemState } from '../../shared/component-store/common-component-store';
import { map } from 'rxjs/operators';

// Extend ItemState to include pod-specific properties
interface PodState extends ItemState<IPod> {
  showPodFormModal: boolean;
  showPodPendingModal: boolean;
  showInviteModal: boolean;
  podsEvents: any;
}

@Injectable({
  providedIn: 'root',
})
export class PodStore extends CommonComponentStore<IPod> {
  constructor(podService: PodService) {
    super(podService, {
      createdId: null,
      item: null,
      items: null,
      loading: false,
      showPodFormModal: false,
      showPodPendingModal: false,
      showInviteModal: false,
      collectionName: 'pods',
      podsEvents: null,
    } as any);
  }

  selectShowFormModal() {
    return this.state$.pipe(map((state: PodState) => state.showPodFormModal));
  }

  updateShowFormModal(value: boolean) {
    this.patchState({ showPodFormModal: value } as any);
  }

  selectShowPendingModal() {
    return this.select((state: PodState) => state.showPodPendingModal);
  }

  updateInviteModal(value) {
    this.patchState({ showInviteModal: value } as any);
  }

  selectInviteModal() {
    return this.select((state: PodState) => state.showInviteModal);
  }

  updateShowPendingModal(value) {
    this.patchState({ showPodPendingModal: value } as any);
  }
}

